import React from 'react'
import { Image } from 'react-bootstrap'

export default function Loader() {
    return (
        <>
<div className="d-flex justify-content-center ">
  <div className="spinner-border" role="status">
    <span className="visually-hidden"></span>
  </div>
</div>


        </>
    )
}
